module.exports = __webpack_public_path__ + "img/Beispiel-Vorschaubild-Video_2.74ba83b1.jpg";